import { useDisclosure } from '@chakra-ui/hooks';
import React, { useRef, useState } from 'react';
import firebase from '../Helpers/Firebase';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Input,
    Button,
    Textarea,
    useToast
  } from "@chakra-ui/react"

  

const firestore = firebase.firestore();


export default function InitialFocus(props) {
  
    const initialRef = useRef();
    const finalRef = useRef();
    const hostsRef = firestore.collection('hosts');
    const toast = useToast();


    const initialValues = {
        fullName: '',
        phone: '',
        email: '',
        message: ''

    }

    const [values, setValues] = useState(initialValues);
    const [isLoading, setLoading] = useState(false);



    const handleChange = e => {
        var { name, value } = e.target;
        setValues({
            ...values, 
            [name]: value,
        })

    }

    const addUser = async(e) => {
        e.preventDefault();
        setLoading(true)

        await hostsRef.add({
            fullName: values.fullName,
            phone: values.phone,
            email: values.email,
            message: values.message,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          });
          toast({
            title: "Thank you.",
            description: "Thank you for signing up.",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
      
          setLoading(false);

        setValues({...initialValues});
        e.target.reset();
    }


    return (
        
      <div>

        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={props.isOpen}
          onClose={props.onClose}

        >
          <ModalOverlay />
          <ModalContent m={4}>
              
            <ModalHeader>Sign up as a host</ModalHeader>
            <ModalCloseButton />
            <form onSubmit={addUser}>
            <ModalBody pb={6}>
              <FormControl >
                <FormLabel>First name</FormLabel>
                <Input ref={initialRef} placeholder="Full Name" name="fullName" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Email</FormLabel>
                <Input ref={finalRef} placeholder="Email" type="email" name="email" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Phone Number</FormLabel>
                <Input ref={finalRef} placeholder="Phone Number" type="tel" name="phone" onChange={handleChange} />
              </FormControl>
              <FormControl mt={5}>
                <FormLabel>Message</FormLabel>
                <Textarea ref={finalRef} placeholder="What are you looking to host?"  name="message" onChange={handleChange} />
              </FormControl>

            </ModalBody>
            <ModalFooter>
              <Button  type="submit" colorScheme="blue" mr={3}       isLoading={isLoading}  
                            disabled={(values.email && values.fullName && values.phone && values.message) ? false : true}>
                Submit
              </Button>
              <Button onClick={props.onClose}>Cancel</Button>
            </ModalFooter>
            </form>
          </ModalContent>
        </Modal>
      </div>
    )
  }